<template>
  <div>
    <div align="left"></div>
    <app-faq-category></app-faq-category>
    <br />
  </div>
</template>

<script>
import Faq from './component/faq';
import Faq_Category from './component/faq_category';

export default {
  components: {
    appFaq: Faq,
    appFaqCategory: Faq_Category,
  },
};
</script>

<style>
</style>
